document.documentElement.setAttribute("data-browser", navigator.userAgent);

$(document).on('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', '.steps .step', function () {
    $(this).addClass('step-after-animation')
})

$(document).on('click', '.stop-propagation', function (e) {
    if (!e)
        e = window.event;

    //IE9 & Other Browsers
    if (e.stopPropagation) {
        e.stopPropagation();
    }
    //IE8 and Lower
    else {
        e.cancelBubble = true;
    }
    e.preventDefault()
})
